import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import type { AuthTheme } from './constants';

interface AuthThemeToggleProps {
  currentTheme: AuthTheme;
  onToggle: (theme: AuthTheme) => void;
}

/**
 * Theme toggle for auth pages (login/register)
 * Allows switching between Invol and Dr. Böse themes for demo/testing
 */
export function AuthThemeToggle({ currentTheme, onToggle }: AuthThemeToggleProps) {
  return (
    <motion.div
      className="fixed bottom-4 right-4 z-50"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6, duration: 0.3 }}
    >
      <div className="flex items-center gap-1 bg-white/90 backdrop-blur-sm rounded-full px-1.5 py-1.5 shadow-lg border border-slate-200/50">
        <button
          onClick={() => onToggle('invol')}
          className={cn(
            'px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-200',
            currentTheme === 'invol'
              ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-md'
              : 'text-slate-500 hover:text-slate-700 hover:bg-slate-100'
          )}
        >
          Invol
        </button>
        <button
          onClick={() => onToggle('drboese')}
          className={cn(
            'px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-200',
            currentTheme === 'drboese'
              ? 'bg-[rgb(255,211,52)] text-black shadow-md'
              : 'text-slate-500 hover:text-slate-700 hover:bg-slate-100'
          )}
        >
          Dr. Böse
        </button>
      </div>
    </motion.div>
  );
}
